import { PUBLIC_ACCESS_OPTIONS } from "../../utils/accessMapConstants";

/**
 * Shared field icons for cards + details/edit modals.
 * Cards show icon-only rows; modals show icon + full field name so users can learn the vocabulary.
 */
export const FIELD_ICONS = {
  // Card / shared field vocabulary
  created: "fi fi-rr-calendar",
  publicAccess: "fi fi-rr-globe",
  myRole: "fi fi-rr-user",
  template: "fi fi-rr-template-alt",
  lastUpdated: "fi fi-rr-clock",
  status: "fi fi-rr-flag",
  rating: "fi fi-rr-star",
  tags: "fi fi-rr-tags",
  searchBy: "fi fi-rr-search",

  // Modal field vocabulary (not all appear on cards)
  title: "fi fi-rr-text",
  description: "fi fi-rr-align-left",
  shareLink: "fi fi-rr-link",
  teamMembers: "fi fi-rr-users",
  teamMemberSettings: "fi fi-rr-users-gear",
  mapConfig: "fi fi-rr-map",
  mapViewName: "fi fi-rr-picture",
  mapCenter: "fi fi-rr-marker",
  mapZoom: "fi fi-rr-zoom-in",
  mapStyle: "fi fi-rr-palette",

  // Entity modal vocabulary
  entityType: "fi fi-rr-layer-plus",
  entityNodes: "fi fi-rr-marker",
  fillColor: "fi fi-rr-fill",
  strokeColor: "fi fi-rr-palette",
  fillOpacity: "fi fi-rr-eye",
  strokeOpacity: "fi fi-rr-opacity",
  strokeWeight: "fi fi-rr-horizontal-rule",
  radius: "fi fi-rr-circle",
  size: "fi fi-rr-resize",
  customIcon: "fi fi-rr-picture",
  lineStyle: "fi fi-rr-minus",
};

/**
 * Public-access *option* icons (what is selected), distinct from the field-family globe.
 * Used on cards, radios, and the current-state banner.
 */
export const PUBLIC_ACCESS_OPTION_ICONS = {
  [PUBLIC_ACCESS_OPTIONS.DEFAULT]: "fi fi-rr-sitemap",
  [PUBLIC_ACCESS_OPTIONS.PROTECTED]: "fi fi-rr-lock",
  [PUBLIC_ACCESS_OPTIONS.NONE]: "fi fi-rr-lock",
  [PUBLIC_ACCESS_OPTIONS.VIEW]: "fi fi-rr-eye",
  [PUBLIC_ACCESS_OPTIONS.EDIT]: "fi fi-rr-edit",
  // Legacy / alias keys from getPublicAccessLevel / cards
  restricted: "fi fi-rr-lock",
};

/**
 * @param {string|null|undefined} level - UI option or level key (default/protected/view/edit/…)
 * @returns {string} Flaticon class string
 */
export function getPublicAccessOptionIcon(level) {
  if (!level) return PUBLIC_ACCESS_OPTION_ICONS[PUBLIC_ACCESS_OPTIONS.PROTECTED];
  const key = String(level).toLowerCase();
  return (
    PUBLIC_ACCESS_OPTION_ICONS[key] ||
    PUBLIC_ACCESS_OPTION_ICONS[PUBLIC_ACCESS_OPTIONS.PROTECTED]
  );
}
